import { Environment, i18nHash } from './environment.schema';

export const environment = {
  production: true,
  i18nHash: i18nHash,
  address: sessionStorage.getItem('envTEST')
    ? 'https://api.dashboardtest.behamics.com/api'
    : 'https://api.dashboard.behamics.com/api',
  statistics: 'https://statistics.behamics.com',
  bugsProject: 'https://bugs.behamics.com',
  emailserver: 'https://testemailserver.behamics.com',
  modelautomation: 'https://automation.behamics.com',
  autoscript: 'http://autoscript.behamics.com',
  seo: 'https://seo1.behamics.com',
  wcag: 'https://wcag.behamics.com',
  ads: 'https://ads.behamics.com',
  golive: 'https://golive.behamics.com',
} as const satisfies Environment;
